const STORAGE_PREFIX = 'family_tree_';

export function getData<T>(key: string, defaultValue: T): T {
  try {
    const item = localStorage.getItem(getStorageKey(key));
    return item ? JSON.parse(item) : defaultValue;
  } catch {
    return defaultValue;
  }
}

export function setData<T>(key: string, value: T): void {
  try {
    localStorage.setItem(getStorageKey(key), JSON.stringify(value));
  } catch (error) {
    console.error(`Error saving to localStorage:`, error);
  }
}

export function removeData(key: string): void {
  try {
    localStorage.removeItem(getStorageKey(key));
  } catch (error) {
    console.error(`Error removing from localStorage:`, error);
  }
}

export function clearAllData(): void {
  try {
    Object.keys(localStorage)
      .filter(key => key.startsWith(STORAGE_PREFIX))
      .forEach(key => localStorage.removeItem(key));
  } catch (error) {
    console.error(`Error clearing localStorage:`, error);
  }
}

function getStorageKey(key: string): string {
  return `${STORAGE_PREFIX}${key}`;
}

// Aliases for backward compatibility
export const getStorageItem = getData;
export const setStorageItem = setData;
export const removeStorageItem = removeData;
export const clearAllStorage = clearAllData;